<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="3">
              <SelectEmpresa @onChanged="empresas = $event" :multiple="true" />
            </v-col>

            <v-col cols="12" sm="12" md="3">
              <SelectColaborador
                ref="selectColaborador01"
                v-show="!todosColaboradores"
                :multiple="true"
                :empresas="empresas"
                @onChanged="colaboradores = $event"
              />
            </v-col>

            <v-col cols="12">
              <v-checkbox
                v-model="todosColaboradores"
                label="Para todos vendedores"
                color="blue darken-2"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="6">
              <SelectCampanha :empresas="empresas" @onChanged="campanha = $event" />
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>

            <template v-if="!todosColaboradores">
              <v-col cols="12" sm="12" v-for="(colaborador, i) in colaboradores" :key="i">
                <v-card>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-btn
                          class="mr-2"
                          color="red"
                          x-small
                          fab
                          icon
                          @click="removeColaborador(colaborador)"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <span style="font-weight: bold; font-size: 11pt">{{ colaborador.nome }}</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <input
                          ref="inputImageFile"
                          type="file"
                          accept="image/*"
                          @change="addImageFile(i, colaborador.cpf)"
                          style="display: none"
                        />
                        <v-btn
                          color="blue darken-2"
                          :title="colaborador.nome"
                          rounded
                          outlined
                          dark
                          small
                          @click="$refs.inputImageFile[i].click()"
                        >
                          <v-icon left>mdi-image</v-icon>Adicionar Imagem
                        </v-btn>
                        <span>{{ getNameImage(colaborador.cpf) }}</span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>

            <template v-if="todosColaboradores">
              <v-col cols="12" sm="12">
                <input
                  ref="inputImageFileAll"
                  type="file"
                  accept="image/*"
                  @change="addImageFile(0, 'all')"
                  style="display: none"
                />
                <v-btn
                  color="blue darken-2"
                  title="Adicionar Imagem"
                  rounded
                  outlined
                  dark
                  small
                  @click="$refs.inputImageFileAll.click()"
                >
                  <v-icon left>mdi-image</v-icon>Adicionar Imagem
                </v-btn>
                <span>{{ getNameImage('all') }}</span>
              </v-col>
            </template>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row dense>
            <v-col cols="12" align="center">
              <v-btn
                v-if="Object.keys(imagesFiles).length > 0"
                color="blue darken-2"
                rounded
                outlined
                dark
                small
                @click="sendImages()"
              >
                <v-icon left>mdi-upload</v-icon>
                Enviar {{ todosColaboradores ? ' Imagem' : ' Imagens' }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { Arquivos } from "@/services/materiais";

export default {
  name: "ImageUpload",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectColaborador: () => import("@/components/select/SelectColaborador"),
    SelectCampanha: () => import("@/components/select/SelectCampanha")
  },

  data() {
    return {
      empresas: [],
      colaboradores: [],
      todosColaboradores: true,

      imagesFiles: new Object()
    };
  },

  methods: {
    addImageFile(index, cpf) {
      let file =
        cpf != "all"
          ? this.$refs.inputImageFile[index].files[0]
          : this.$refs.inputImageFileAll.files[0];

      if (cpf == "all") {
        this.imagesFiles = new Object();
      }
      this.imagesFiles[cpf] = file;
      this.$forceUpdate();
    },

    getNameImage(cpf) {
      let file = this.imagesFiles[cpf];
      return file ? file.name : "";
    },

    sendImages() {
      if (!this.campanha) {
        this.$toast.warning("Selecione uma campanha");
        return;
      }

      if (this.todosColaboradores) this.sendImageAllColaboradores();
      else this.sendImageByColaborador();
    },

    async sendImageAllColaboradores() {
      if (!this.imagesFiles["all"]) {
        this.$swal.warning("Por favor, selecione uma imagem");
        return;
      }

      let descricao = await this.$swal.inputText(
        "Descrição para a imagem",
        true,
        "Descrição"
      );
      if (!descricao || descricao == "") {
        this.$toast.warning("É necessário informar descrição da imagem");
        return;
      }

      try {
        this.$loading.setLoading(true, "Enviando para todos vendedores");

        for (const empresa of this.empresas) {
          await new Arquivos().uploadImageByColaborador(
            empresa,
            "public",
            this.campanha,
            descricao,
            this.imagesFiles["all"]
          );
        }

        this.$swal.success("Imagem enviada com sucesso");
        this.imagesFiles = new Object();
      } catch (error) {
        console.error(error);
        this.$swal.error(error);
      } finally {
        this.$loading.setLoading(false);
      }
    },

    async sendImageByColaborador() {
      let error = "";
      for (let colaborador of this.colaboradores) {
        if (!this.imagesFiles[colaborador.cpf]) {
          error += `${colaborador.nome}<br>`;
        }
      }
      if (error != "") {
        this.$swal.warning(
          "",
          `Por favor, selecione uma imagem para os vendedores: <br><br>${error}`
        );
        return;
      }

      let descricao = await this.$swal.inputText(
        "Descrição para a imagem",
        true,
        "Descrição"
      );
      if (!descricao || descricao == "") {
        this.$toast.warning("É necessário informar descrição da imagem");
        return;
      }

      try {
        for (let empresa of this.empresas) {
          const colaboradoresDaEmpresa = this.colaboradores
            .map(colaborador =>
              colaborador.empresas.indexOf(empresa) >= 0 ? colaborador : ""
            )
            .filter(colaborador => colaborador !== "");

          if (colaboradoresDaEmpresa.length > 0) {
            for (const colaborador of colaboradoresDaEmpresa) {
              this.$loading.setLoading(
                true,
                `Enviando imagem do vendedor: ${colaborador.nome}`
              );
              await new Arquivos().uploadImageByColaborador(
                empresa,
                colaborador.cpf,
                this.campanha,
                descricao,
                this.imagesFiles[colaborador.cpf]
              );
            }
          }
        }

        this.$swal.success("Imagens enviadas com sucesso");
        this.imagesFiles = new Object();
      } catch (error) {
        console.error(error);
        this.$swal.error(`Erro ao enviar imagens: ${JSON.stringify(error)}`);
      } finally {
        this.$loading.setLoading(false);
      }
    },

    removeColaborador(colaborador) {
      this.$refs.selectColaborador01.removeSelected(colaborador);
      if (this.imagesFiles[colaborador.cpf])
        delete this.imagesFiles[colaborador.cpf];
    }
  },

  watch: {
    todosColaboradores() {
      this.imagesFiles = new Object();
    }
  }
};
</script>
